<!--订单发起采购页面-->
<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true" :destroy-on-close="true"
    custom-class="max-dialog">
    <el-form :model="form" ref="form1" :rules="rules">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="供应商" :label-width="formLabelWidth">
          {{orderdata.pcustomer}}
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="收货地址" :label-width="formLabelWidth">
          <b>{{orderdata.deliveryaddress}}</b>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="客户" :label-width="formLabelWidth" prop="customercode">
          <template v-if="isKeda">
            <span>{{kedaConfig.login}} {{kedaConfig.password}}</span>
          </template>
          <template v-else>
            <el-select v-model="form.customercode" placeholder="请选择" filterable style="width: 300px" size="mini" @change="setdmscustomecode"><!--:disabled="!caneditCus"-->
              <el-option
                v-for="item in customers"
                :key="item.code"
                :label="item.name+' '+item.dmscustomecode"
                :value="item.code">
              </el-option>
            </el-select>{{dmscustomecode}}
          </template>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="!isKeda">
        <el-form-item label="仓库" :label-width="formLabelWidth" prop="cangkucode">
          <el-select v-model="form.cangkucode" placeholder="请选择" filterable style="width: 300px" size="mini" @change="getTPDStockQty">
            <el-option
              v-for="item in stocks"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="备注" :label-width="formLabelWidth" prop="comment2">
          <el-input v-model="form.comment2" auto-complete="off" maxlength="40" size="mini"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="染色备注" :label-width="formLabelWidth" prop="comment">
          <el-input v-model="form.comment" auto-complete="off" maxlength="40" size="mini"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="商品" :label-width="formLabelWidth">
          <el-table
            :data="buydetail"
            size="mini"
            stripe
            border
            style="width: 100%;">
            <el-table-column
              prop="seedcode"
              label="编码"
              align="left"
              header-align="center"  :show-overflow-tooltip="true"
              width="100">
            </el-table-column>
            <el-table-column
              prop="seedname"
              label="名称"
              align="left" width="200" :show-overflow-tooltip="true"
              header-align="center">
            </el-table-column>
            <el-table-column
              prop="productid"
              label="供应商编码"
              align="left"
              header-align="center"  :show-overflow-tooltip="true"
              width="130">
            </el-table-column>
            <el-table-column
              prop="Number"
              label="数量"
              align="left"
              header-align="center"
              width="70">
            </el-table-column>
            <el-table-column
              prop="tpdnumber" v-if="selectTPD"
              label="TPD库存"
              align="left"
              header-align="center"
              width="70">
              <template slot-scope="scope">
                <i class="el-icon-loading" v-if="scope.row.tpdnumber=='load'"></i>
                <span v-else>{{scope.row.tpdnumber}}
                <i class="el-icon-warning" style="color: red;font-size:12pt" v-if="scope.row.tpdnumber<scope.row.Number"></i></span>
              </template>
            </el-table-column>
            <el-table-column
              label="光度"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                {{getPackage(scope.row)}}
              </template>
            </el-table-column>
            <el-table-column
              label="要求直径"
              align="left"
              header-align="center"  width="80">
              <template slot-scope="scope">
                <el-input v-model="scope.row.Diameter" auto-complete="off" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="商业直径"
              align="left"
              header-align="center"  width="80">
              <template slot-scope="scope">
                <el-input v-model="scope.row.CommercialDiameter" auto-complete="off" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="其他参数"
              align="left"
              header-align="center">
              <template slot-scope="scope">
                {{getParam(scope.row)}}
              </template>
            </el-table-column>
            <!--<el-table-column label="操作" align="center" width="90" fixed="right">-->
              <!--<template slot-scope="scope">-->
                <!--<el-button-->
                  <!--size="mini"-->
                  <!--@click="handleEdit(scope.$index, scope.row)">编辑-->
                <!--</el-button>-->
              <!--</template>-->
            <!--</el-table-column>-->
          </el-table>
          <el-button type="warning" size="mini" v-if="neewLensCalcution&&hasproduct&&buydetail.length==1&&buydetail[0].Number==1" @click="showcopyRow">
            增加商品（不生产）
          </el-button>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="userspec">
        <el-form-item label="特殊加工" :label-width="formLabelWidth">
          <el-table
            :data="specialgoods"
            size="mini"
            stripe
            border
            style="width: 100%;">
            <el-table-column
              label="光度"
              align="left"
              header-align="center"  width="120" fixed>
              <template slot-scope="scope">
                {{getPackage(scope.row)}}
              </template>
            </el-table-column>
            <el-table-column
              label="膜层"
              align="left"
              header-align="center"  width="130">
              <template slot-scope="scope">
                <el-select v-model="scope.row.CoatingCode" size="mini" @change="selectOther(scope.row,'CoatingCode')">
                  <el-option v-for="item in CoatingCode" :key="item.value"
                             :label="item.name"
                             :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="割边"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-select v-model="scope.row.EdgingCode" size="mini" @change="selectOther(scope.row,'EdgingCode')">
                  <el-option v-for="item in EdgingCode" :key="item.value"
                             :label="item.name"
                             :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="染色"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-select v-model="scope.row.TintingCode" size="mini" @change="selectOther(scope.row,'TintingCode')">
                  <el-option v-for="item in TintingCode" :key="item.value"
                             :label="item.name"
                             :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="其他加工"
              align="left"
              header-align="center"  width="160">
              <template slot-scope="scope">
                <el-select v-model="scope.row.OtherProcessCode" size="mini"  multiple >
                  <el-option v-for="item in OtherProcessCode" :key="item.value"
                             :label="item.name"
                             :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="镜框类型"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-select v-model="scope.row.FrameType" size="mini" @change="selectOther(scope.row,'FrameType')">
                  <el-option  label="" value=""></el-option>
                  <el-option  label="无框" value="Rimless"></el-option>
                  <el-option  label="全框" value="Full"></el-option>
                  <el-option  label="半框" value="Nylor"></el-option>
                  <el-option  label="其它" value="Other"></el-option>
                  <el-option  label="自定义" value="Shell"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="镜框形状"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-select v-model="scope.row.FrameShape" size="mini" @change="selectOther(scope.row,'FrameShape')">
                  <el-option  label="" value=""></el-option>
                  <el-option  label="1 椭圆形" value="1"></el-option>
                  <el-option  label="2 圆形" value="2"></el-option>
                  <el-option  label="3 飞行员" value="3"></el-option>
                  <el-option  label="4 猫眼形" value="4"></el-option>
                  <el-option  label="5 卵形" value="5"></el-option>
                  <el-option  label="6 切角方形" value="6"></el-option>
                  <el-option  label="7 长方形" value="7"></el-option>
                  <el-option  label="8 切角圆形" value="8"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="边缘厚度"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.MinimumET" placeholder="" style="width: 75px" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="中心厚度"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.CT" style="width: 75px" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="基弯"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.Base" placeholder="0～20" style="width: 75px" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="移心/棱镜"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-select v-model="scope.row.Prism1" size="mini">
                  <el-option  label="" value=""></el-option>
                  <el-option  label="移心" value="移心"></el-option>
                  <el-option  label="棱镜" value="棱镜"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="数值1"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.Decenter1" auto-complete="off" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="方向1"
              align="left"
              header-align="center"  width="130">
              <template slot-scope="scope">
                <el-select v-model="scope.row.Direction1" size="mini">
                  <el-option  label="" value=""></el-option>
                  <el-option  label="向内0" value="0" v-if="scope.row.type=='R'"></el-option>
                  <el-option  label="向外180" value="180" v-if="scope.row.type=='R'"></el-option>
                  <el-option  label="向内180" value="180" v-if="scope.row.type=='L'"></el-option>
                  <el-option  label="向外0" value="0" v-if="scope.row.type=='L'"></el-option>
                  <el-option  label="向上90" value="90"></el-option>
                  <el-option  label="向下270" value="270"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="数值2"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.Decenter2" auto-complete="off" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="方向2"
              align="left"
              header-align="center"  width="130">
              <template slot-scope="scope">
                <el-select v-model="scope.row.Direction2" size="mini">
                  <el-option  label="" value=""></el-option>
                  <el-option  label="向内0" value="0" v-if="scope.row.type=='R'"></el-option>
                  <el-option  label="向外180" value="180" v-if="scope.row.type=='R'"></el-option>
                  <el-option  label="向内180" value="180" v-if="scope.row.type=='L'"></el-option>
                  <el-option  label="向外0" value="0" v-if="scope.row.type=='L'"></el-option>
                  <el-option  label="向上90" value="90"></el-option>
                  <el-option  label="向下270" value="270"></el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="userspec">
        <el-form-item label="其他参数" :label-width="formLabelWidth">
          <el-table
            :data="specialgoodsV2"
            size="mini"
            stripe
            border
            style="width: 100%;">
            <el-table-column
              label="光度"
              align="left" fixed
              header-align="center"  width="120">
              <template slot-scope="scope">
                {{getPackage(scope.row)}}
              </template>
            </el-table-column>
            <el-table-column
              label="姓名首字母"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.WearerInitials" auto-complete="off" size="mini" maxlength="10" @change="selectOtherV2(scope.row,'WearerInitials')"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="眼轴半径"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.EyeRotationCenter" placeholder="16.0～38.0 一位小数" auto-complete="off" size="mini" maxlength="10"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="头部转动角"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.HeadCapeAngle" placeholder="-100～100，整数" auto-complete="off" size="mini" maxlength="10" @change="selectOtherV2(scope.row,'HeadCapeAngle')"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="激光刻印代码"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.EngravingCode" auto-complete="off" size="mini" maxlength="10" @change="selectOtherV2(scope.row,'EngravingCode')"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="阅读距离"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.DLE" placeholder="20～60，整数" auto-complete="off" size="mini" maxlength="10" @change="selectOtherV2(scope.row,'DLE')"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="通道长度"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-select v-model="scope.row.ProgressiveLength" size="mini">
                  <el-option  label="" value=""></el-option>
                  <el-option  label="14" value="14"></el-option>
                  <el-option  label="15" value="15"></el-option>
                  <el-option  label="16" value="16"></el-option>
                  <el-option  label="17" value="17"></el-option>
                  <el-option  label="18" value="18"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="主势眼"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-select v-model="scope.row.DominantEye" size="mini" @change="selectOtherV2(scope.row,'DominantEye')">
                  <el-option  label="" value=""></el-option>
                  <el-option  label="右眼" value="Right"></el-option>
                  <el-option  label="左眼" value="Left"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="头/眼动比"
              align="left"
              header-align="center"  width="120">
              <template slot-scope="scope">
                <el-input v-model="scope.row.HeadEyeCoEff" placeholder="0.00～0.99，两位小数" auto-complete="off" size="mini" maxlength="10"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="稳定系数"
              align="left"
              header-align="center"  width="120">
              <template slot-scope="scope">
                <el-input v-model="scope.row.StabilityCoEff" placeholder="0.00～0.99，两位小数" auto-complete="off" size="mini" maxlength="10"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="近用辐辏"
              align="left"
              header-align="center"  width="110">
              <template slot-scope="scope">
                <el-input v-model="scope.row.InsertNearVision" placeholder="0～7.0，一位小数" auto-complete="off" size="mini" maxlength="10"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="通道长度(1/10mm)"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-select v-model="scope.row.ProgressiveLengthGen7" size="mini">
                  <el-option  label="" value=""></el-option>
                  <el-option  label="140" value="140"></el-option>
                  <el-option  label="150" value="150"></el-option>
                  <el-option  label="160" value="160"></el-option>
                  <el-option  label="170" value="170"></el-option>
                  <el-option  label="180" value="180"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="镜架弯度"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.Wrap" placeholder="0～25，整数" auto-complete="off" size="mini" maxlength="10" @change="selectOtherV2(scope.row,'Wrap')"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="镜架倾角"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.Pantoscopic" placeholder="-5～25，整数" auto-complete="off" size="mini" maxlength="10" @change="selectOtherV2(scope.row,'Pantoscopic')"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="单侧镜眼距"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.Vertex" placeholder="5～22，整数" auto-complete="off" size="mini" maxlength="10" ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="NVB"
              align="left"
              header-align="center"  width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.NearVisionBehaviour" auto-complete="off" size="mini" maxlength="10" @change="selectOtherV2(scope.row,'NearVisionBehaviour')"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-col>
    </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible=false">取 消</el-button>
      <el-button type="primary" :loading="loading" v-if="canpost&&hasproduct" @click="saveData">
        提交给供应商
      </el-button>
      <!--<el-button type="danger" :loading="loading" v-if="canpost&&hasproduct&&showbatch" @click="saveDataBatch('')">-->
        <!--提交批量单(拆成2片)-->
      <!--</el-button>-->
    </div>
    <el-drawer
      title="该镜片的生产必须使用两个镜片的数据！"
      :visible.sync="drawer" :wrapperClosable="false" :append-to-body="true"
      :direction="'rtl'">
      <el-form :model="otherrow" ref="otherrow1">
      <el-form-item label="" :label-width="formLabelWidth"  style="height: 24px">
        {{otherrow.type}}
      </el-form-item>
      <el-form-item label="球镜" :label-width="formLabelWidth" style="height: 24px">
        <el-input v-model="otherrow.Y" auto-complete="off" size="mini" style="width: 80%"></el-input>
      </el-form-item>
      <el-form-item label="柱镜" :label-width="formLabelWidth" style="height: 24px">
        <el-input v-model="otherrow.X" auto-complete="off" size="mini" style="width: 80%"></el-input>
      </el-form-item>
        <el-form-item label="要求直径" :label-width="formLabelWidth" style="height: 24px">
          <el-input v-model="otherrow.Diameter" auto-complete="off" size="mini" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="商业直径" :label-width="formLabelWidth" style="height: 24px">
          <el-input v-model="otherrow.CommercialDiameter" auto-complete="off" size="mini" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="ADD" :label-width="formLabelWidth" style="height: 24px">
          <el-input v-model="otherrow.ADD" auto-complete="off" size="mini" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="轴位" :label-width="formLabelWidth" style="height: 24px">
          <el-input v-model="otherrow.A" auto-complete="off" size="mini" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="" :label-width="formLabelWidth">
        <el-button type="primary" @click="copyRow" class="qrbtn" size="mini">确定增加</el-button>
        <el-button type="info" @click="drawer=false" size="mini" class="qrbtn">取消</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </el-dialog>
</template>

<script>

  import {essiLorPartner,essiLorSaleOrder,StockCode,TPDStockQty,TPDStockCode,getSupplyConfig,getGoodsMapping} from '@/api/ossi';
  import {listProductID,getProductIDParam} from '@/api/set/jxcgooddetail';
  import {getBySerial} from '@/api/set/externaldept';

  export default {
    name: 'BuyfromEssilor',
    data() {
      return {
        drawer: false,
        title: '发起采购',
        selectTPD: false,
        caneditCus: true,
        isKeda: false,
        kedaConfig: null,
        showbatch: false,
        loading: false,
        userspec: false,//特殊加工商品
        canpost: false,
        libojiagong: false,//是否要求所有参数必填  镜宽 镜高 梁宽  梁高 镜框类型 镜框形状 瞳距 瞳高
        hasproduct: false,
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        customers: [],
        orderdata: {},
        buydetail: [],
        specialgoods: [],
        neewLensCalcution: false,
        specialgoodsV2: [],
        dmscustomecode:"",
        stocks: [],
        productid: '',
        parames: [{name: '瞳距'}, {name: '瞳高'}, {name: '梁宽'}, {name: '镜宽'}, {name: '镜高'}],
        CoatingCode: [{name: '', value: ''}, {name: '钻晶A+', value: 'CrizalA+'}, {
          name: '钻晶A3',
          value: 'CrizalA3'
        }, {name: '钻晶A4', value: 'CrizalA4'}, {name: '防雾', value: 'Optifog'}],//膜层代码
        EdgingCode: [{name: '', value: ''}, {name: '塑料全框', value: '200'}, {name: '金属全框', value: '201'}, {
          name: '无框',
          value: '203'
        }, {name: '半框', value: '204'}],//割边,{name:'来架加工',value:'Edging'}
        OtherProcessCode: [{name: '', value: ''},
          {name: 'EQR', value: 'EQR'},
          {name: 'BL141 141粉红渐进', value: 'BLT3'},
          {name: 'BL14A 14A紫红渐进', value: 'BLT1'},
          {name: 'BLG 生理灰', value: 'BLT5'},
          {name: 'BLG11 G11蓝灰渐进色', value: 'BLT2'},
          {name: 'BLG13 G13灰色渐进色', value: 'BLT4'},
          {name: 'BLG15 G15灰绿', value: 'BLT6'},
          {name: 'BLGB 生理茶', value: 'BLT7'},
          {name: 'EDGPOL 镜片抛光', value: '205'},
          {name: 'EDGSPALT 改样', value: '209'},
          {name: 'PRISM1 棱镜附加费_10', value: '303'},
          {name: 'PRISM2 棱镜附加费_20', value: '319'},
          {name: 'PRISM3 棱镜附加费_30', value: '320'},
          {name: 'PRISM4 棱镜附加费_50', value: '321'},
          {name: 'WEARINITIAL 个人激光标记', value: 'INI'},
        ],
        TintingCode: [{name: '', value: ''},
          {name: '染色(UK)', value: '401B'},
          {name: '染色_单色', value: '402'},
          {name: '染色_双色', value: '403'},
          {name: '染色_来色板(单)', value: '405'},
          {name: '染色_来色板(双)', value: '490'},
        ],//染色
        form: {
          ssotoken: '',
          customercode: '',
          cangkucode: '',
          comment: '',//备注
          comment2: ''
        },
        rules: {////////定义正则验证字段。
          customercode: [
            {required: true, message: '客户必选！', trigger: 'blur'},
          ],
          cangkucode: [],
        },
        otherrow: {type: "", Y: "", X: "", Diameter: "", CommercialDiameter: "", ADD: "", A: ""}
      }
    },
    props: {
      buytype: {
        default: 'buy&sale'
      },
      showTPD: {
        default: false
      },
      isauto: {
        default: false,
      }
    },
    methods: {
      setdmscustomecode(){
        this.dmscustomecode='';
        for (let i in this.customers) {
          if (this.customers[i].code == this.form.customercode) {
            this.dmscustomecode =this.customers[i].dmscustomecode;
            break;
          }
        }
      },
      selectOther(row, column) {
        if (column == 'FrameType') {
          var MinimumET = '';//Rimless：1.6，Full：1.0，Nylor：1.8，Other：2.5，Shell：2.0
          switch (row[column]) {
            case 'Rimless':
              MinimumET = 1.6;
              break;
            case 'Full':
              MinimumET = 1.0;
              break;
            case 'Nylor':
              MinimumET = 1.8;
              break;
            case 'Other':
              MinimumET = 2.5;
              break;
            case 'Shell':
              MinimumET = 2.0;
              break;
          }
          for (let i in this.specialgoods) {
            this.specialgoods[i].MinimumET = MinimumET
          }
        }
        for (let i in this.specialgoods) {
          this.specialgoods[i][column] = row[column]
        }
      },
      selectOtherV2(row, column) {
        for (let i in this.specialgoodsV2) {
          this.specialgoodsV2[i][column] = row[column]
        }
      },
      show(ssotoken, buydetail, data,bomseedcode) {
        this.dialogSeeVisible = true
        this.loading = false;
        this.dmscustomecode="";
        this.canpost = false;
        this.caneditCus = true;
        this.isKeda = false;
        this.kedaConfig = null;
        this.orderdata = data;
        this.form.customercode = ''
        this.form.ssotoken = ssotoken;
        this.form.comment = ''
        this.form.comment2 = ''
        this.libojiagong = false
        //console.log(this.orderdata)
        if (this.orderdata.erpserial) {
          this.form.comment2 = this.orderdata.erpserial;
        }
        this.stocks = []
        this.specialgoods = []
        this.specialgoodsV2 = []
        this.form.cangkucode = ''
        this.userspec = false;
        this.neewLensCalcution = false;

        var itemDetail = JSON.parse(buydetail);
        var items = []
        var totalNu = 0;
        var seedcode = '';
        if (bomseedcode) {
          seedcode += bomseedcode + ';';
        }

        for (var i = itemDetail.length - 1; i >= 0; i--) {
          itemDetail[i].tpdnumber = ''

          if (itemDetail[i].seedcode == 'SFSVSHARKA4-C' || itemDetail[i].seedcode == 'SFSVSHARK159WMCL') {//星趣控 控制下单次推送订单数量
            if (totalNu > 50) {
              this.$message({message: '一次最多提交50片！！', type: 'error'})
              this.dialogSeeVisible = false
              return;
            }
          }

          items.push(itemDetail[i]);
          totalNu += parseInt(itemDetail[i].Number);

          if ((';' + seedcode + ';').indexOf(';' + itemDetail[i].seedcode + ';') == -1) {
            seedcode += itemDetail[i].seedcode + ';';
          }
        }

        //先获取供应商配置，判断是否柯达对接
        getSupplyConfig({ssotoken: ssotoken}).then(configRes => {
          if (configRes.data.code == 0 && configRes.data.obj) {
            var cfg = configRes.data.obj;
            if (cfg.url && cfg.url.toString().startsWith('keda')) {
              this.isKeda = true;
              this.kedaConfig = cfg;
              this.form.customercode = cfg.login;
              this.dmscustomecode = cfg.password;
              this.rules.cangkucode = [];
            } else {
              this.rules.cangkucode = [{required: true, message: '仓库必选！', trigger: 'blur'}];
            }
          }

          //取商品对应的编码
          listProductID({seedcode: seedcode, erpserial: this.orderdata.erpserial}).then(response => {
            this.hasproduct = true;
            var isDingz = false;

            var seedrows = response.data.obj
            var postcontent = response.data.postcontent;
            if (postcontent) {
              var pc = JSON.parse(postcontent);
              if (pc.Address.DeliveryCode) {
                this.form.customercode = pc.Address.DeliveryCode;
                this.caneditCus = false
              }
            }


            var buys = []
            for (let i in items) {
              var hasvalue = false;
              var isSpecial = false;
              items[i].Diameter = '';//客户要求直径
              items[i].CommercialDiameter = '';

              var seedR = {};//商品信息
              for (let j in seedrows) {
                if (items[i].seedcode != seedrows[j].seedcode)
                  continue;

                seedR = seedrows[j];
                break;
              }

              items[i].filltemplate = seedR.filltemplate
              if (items[i].filltemplate == 60) {//特殊加工 跳过
                isSpecial = true;
                continue;
              }

              if (bomseedcode) {
                for (let j in seedrows) {
                  if (bomseedcode != seedrows[j].seedcode)
                    continue;//取替换的产品

                  seedR = seedrows[j];
                  break;
                }
                items[i].filltemplate = seedR.filltemplate
                items[i].seedcode = bomseedcode;
              }

              if (items[i].filltemplate == 20) {//定制片不能从TPD发货
                isDingz = true;
              }

              items[i].seedname = seedR.seedname
              items[i].productid = seedR.seedbarcode
              if (items[i].productid) {
                if (items[i].productid.indexOf('{') > -1) {//需要根据通道取编码
                  var tongdao = items[i]["通道"]
                  var pi = JSON.parse(items[i].productid)
                  items[i].productid = '';
                  if (tongdao) {
                    for (let p in pi) {
                      if (pi[p].name.indexOf(tongdao) > -1) {
                        items[i].productid = pi[p].value;
                        hasvalue = true;
                        break;
                      }
                    }
                  }
                  //取没填通道得
                  if (!hasvalue) {
                    for (let p in pi) {
                      if (pi[p].name == '') {
                        items[i].productid = pi[p].value;
                        hasvalue = true;
                        break;
                      }
                    }
                  }
                } else {
                  hasvalue = true;
                }
              }

              if (!isSpecial) {
                buys.push(items[i]);
                if (!hasvalue)
                  this.hasproduct = false;//商品对应不上
                else
                  this.productid = items[i].productid
              }
            }

            //柯达对接：从供应商对应表获取产品编码
            var self = this;
            if (this.isKeda && buys.length > 0) {
              var kedaSeedcodes = [];
              var kedaSeedcodeMap = {};
              for (let i in buys) {
                var sc = buys[i].seedcode;
                if (kedaSeedcodeMap[sc] === undefined) {
                  kedaSeedcodeMap[sc] = [];
                  kedaSeedcodes.push(sc);
                }
                kedaSeedcodeMap[sc].push(i);
              }
              getGoodsMapping({seedcodes: kedaSeedcodes.join(','), pcustomerserial: data.pcustomerserial}).then(mapRes => {
                if (mapRes.data.code == 0 && mapRes.data.obj) {
                  var mappedCount = 0;
                  for (let m in mapRes.data.obj) {
                    var mapping = mapRes.data.obj[m];
                    if (mapping.productid && kedaSeedcodeMap[mapping.seedcode]) {
                      for (let idx in kedaSeedcodeMap[mapping.seedcode]) {
                        var bi = kedaSeedcodeMap[mapping.seedcode][idx];
                        buys[bi].productid = mapping.productid;
                        if (mapping.seedname) buys[bi].seedname = mapping.seedname;
                        mappedCount++;
                      }
                    }
                  }
                  if (mappedCount > 0) {
                    self.hasproduct = true;
                    self.productid = buys[0].productid;
                  }
                }
                self.finishShowSetup(buys, isDingz, ssotoken, data);
              });
            } else {
              this.finishShowSetup(buys, isDingz, ssotoken, data);
            }
          });
        });
      },
      finishShowSetup(buys, isDingz, ssotoken, data) {
        if (buys.length <= 2) {
          this.userspec = true;
          for (let i in buys) {
            this.specialgoods.push({
              type: buys[i].type,
              X: buys[i].X,
              Y: buys[i].Y,
              Prism1: '',//棱镜
              Prism2: '',
              Decenter1: '',//移心
              Decenter2: '',
              Direction1: '',//方向1
              Direction2: '',
              CoatingName: '',
              EdgingCode: '',//割边
              EdgingName: '',
              OtherProcessCode: '',//其他加工项
              OtherProcessName: '',//其他加工项描述
              CoatingCode: '',//膜层
              TintingCode: '',//染色
              TintingName: '',
              MinimumET: '',//最小边缘厚度
              Base: '',//基弯
              CT: '',//中心厚度
              FrameType: '',//镜框类型
              FrameShape: ''//镜框形状
            })

            this.specialgoodsV2.push({
              type: buys[i].type,
              X: buys[i].X,
              Y: buys[i].Y,
              WearerInitials: null,//姓名首字母 10
              EyeRotationCenter: null,//眼轴半径 10;范围为：16.0～38.0，一位小数，区分左右眼
              HeadCapeAngle: null,//头部转动角 10;范围为：-100～100，整数
              EngravingCode: null,//激光刻印代码
              DLE: null,//阅读距离 范围为：20～60，整数
              ProgressiveLength: null,//通道长度 可选值：14,16,17,18，区分左右眼
              HeadEyeCoEff: null,//头/眼动比 范围为：0.00～0.99，两位小数，区分左右眼
              StabilityCoEff: null,//稳定系数 范围为：0.00～0.99，两位小数，区分左右眼
              InsertNearVision: null,//近用辐辏 范围为：0～7.0，一位小数，区分左右眼
              DominantEye: null,//主势眼（七代产品+）   Right  Left
              ProgressiveLengthGen7: null,//通道长度（七代产品+）可选值：140,160,170,180，区分左右眼
              Wrap: null,//镜架弯度  范围为：0～25，整数
              Pantoscopic: null,//镜架倾角 范围为：-5～25，整数
              Vertex: null,//单侧镜眼距 范围为：-5～25，整数 区分左右眼
              NearVisionBehaviour: null,//NVB   10
            })
          }
        }
        this.buydetail = buys;

        if (this.buydetail.length == 1 && this.buydetail[0].Number == 1) {
          if (this.productid && isDingz) {
            getProductIDParam({productid: this.productid}).then(response => {
              if (response.data.obj && response.data.obj.length > 0) {
                this.neewLensCalcution = response.data.obj[0].LensCalculation == 't';
              }
            })
          }
        }

        if (this.isauto) {

        } else {
          if (this.isKeda) {
            //柯达对接：不需要选仓库和客户，直接可提交
            this.canpost = true;
          } else {
            //取仓库清单
            StockCode({ssotoken: ssotoken}).then(response => {
              if (response.data.code == 0) {
                var d = JSON.parse(response.data.obj)
                for (let key in  d) {
                  if ((isDingz || !this.showTPD) && key.toUpperCase().indexOf("TPD") > -1) {//定制片不能从TPD发货
                    continue;
                  }

                  if (data.cangkuname) {
                    if (key.indexOf(data.cangkuname.replace('仓', '').replace('库', '').replace('总', '')) > -1) {
                      if (key.toUpperCase().indexOf("TPD") > -1 || !this.form.cangkucode) {
                        this.form.cangkucode = d[key];
                      }
                    }
                  }
                  this.stocks.push({name: key, code: d[key]})
                }
                if (this.form.cangkucode == '') {
                  if (this.stocks.length > 0) {
                    this.form.cangkucode = this.stocks[0].code;
                  }
                }
                this.getTPDStockQty();
              }
            });

            //取供应商的客户
            essiLorPartner({ssotoken: ssotoken, customercode: this.orderdata.customerserial}).then(response => {
              if (response.data.code == 0) {
                this.customers = response.data.obj
                if (this.userInfoModel.tenantid == 'd6d0f500-6c34-45e6-b206-b87c368e4469' && this.orderdata.pcustomerserial == '20241229002') {
                  var item = [];
                  for (let i in this.customers) {
                    if (this.customers[i].dmscustomecode == 'SZ283') {
                      item.push(this.customers[i]);
                      this.form.customercode = this.customers[i].code;
                      this.setdmscustomecode();
                      break;
                    }
                  }
                  this.customers = item;
                } else {
                  var hasselData = false;
                  for (let i in this.customers) {
                    if (this.customers[i].dmscustomecode == data.customerserial || this.customers[i].name == data.customername) {
                      this.form.customercode = this.customers[i].code;
                      this.setdmscustomecode();
                      hasselData = true;
                      break;
                    }
                  }
                  if (!hasselData && data.customerserial) {
                    getBySerial({customerserial: data.customerserial}).then(resCusvalue => {
                      if (resCusvalue.data.code == 0 && resCusvalue.data.obj&&resCusvalue.data.obj.shorthandcode) {
                        var shorthandcode=resCusvalue.data.obj.shorthandcode;
                        for (let i in this.customers) {
                          if (this.customers[i].dmscustomecode == shorthandcode||this.customers[i].code == shorthandcode) {
                            this.form.customercode = this.customers[i].code;
                            this.setdmscustomecode();
                            break;
                          }
                        }
                      }
                    })
                  }
                }
                this.canpost = true;
              } else {
                this.$message({
                  message: response.data.msg ? response.data.msg : '登录失败！',
                  type: 'error'
                })
              }
            })
          }
        }
      },
      getTPDStockQty() {
        this.selectTPD = false;
        var cangkuname = ''
        for (let i in this.stocks) {
          if (this.stocks[i].code == this.form.cangkucode) {
            cangkuname = this.stocks[i].name.toUpperCase();
            break;
          }
        }
        //console.log(cangkuname)
        if (cangkuname.indexOf('TPD') == -1 || !this.productid)
          return;
        this.selectTPD = true;
        for (let j in this.buydetail) {
          this.buydetail[j].tpdnumber = 'load';
        }

        TPDStockCode({ssotoken: this.form.ssotoken}).then(response => {
          if (response.data.code == 0) {
            var cangku = JSON.parse(response.data.obj);
            var code = ''
            for (let key in cangku) {
              code = cangku[key]
            }
            if (code) {
              TPDStockQty({
                ssotoken: this.form.ssotoken,
                cangkucode: code,
                projectid: this.productid
              }).then(resTPD => {
                for (let j in this.buydetail) {
                  this.buydetail[j].tpdnumber = '';
                }

                if (resTPD.data.code == 0) {
                  var data = JSON.parse(resTPD.data.obj)
                  if (data.length > 0 && data[0].default_code == this.productid) {
                    for (let i in data[0].skus_info) {
                      var item = data[0].skus_info[i];
                      //   | good_qty_usable | float | 良品可用数量 | |
                      //   | good_qty | float | 良品实际数量 | |
                      //   | non_good_qty_usable | float | 不良品可用数量 | |
                      //   | non_good_qty | float | 不良品实际数量 | |
                      if (item.good_qty_usable > 0) {
                        for (let j in this.buydetail) {
                          if (parseFloat(this.buydetail[j].X) == parseFloat(item.cyl) && parseFloat(this.buydetail[j].Y) == parseFloat(item.sph)) {
                            this.buydetail[j].tpdnumber = item.good_qty_usable;
                            break;
                          }
                        }
                      }
                    }
                  }
                }
              });
            }
          }
        })
      },
      getName(value, codes) {
        if (value) {
          for (let i in codes) {
            if (codes[i].value == value)
              return codes[i].name;
          }
        }
        return ''
      },
      getNameList(value, codes) {
        if (value) {
          var names = []
          for (let i in codes) {
            for (let m in value) {
              if (codes[i].value == value[m]) {
                names.push(codes[i].name);
              }
            }
          }
          if (names.length > 0)
            return names;
        }
        return ''
      },
      showcopyRow() {
        for (let key in this.buydetail[0]) {
          if (key == 'type') {
            this.otherrow[key] = this.buydetail[0][key] == 'R' ? 'L' : 'R';
          } else {
            this.otherrow[key] = this.buydetail[0][key];
          }
        }
        this.drawer = true;
      },
      copyRow() {//增加一条不生产的数据 LensCalculation=0不生产  或 1生产； 该镜片的生产必须使用两个镜片的数据
        var newrow = {}
        for (let key in this.buydetail[0]) {
          switch (key) {
            case 'Y':
              if (this.otherrow.Y == null || this.otherrow.Y == '') {
                newrow.Y = '0.00'
              } else {
                newrow.Y = parseFloat(this.otherrow.Y).toFixed(2);
              }
              break;
            case 'X':
              if (this.otherrow.X == null || this.otherrow.X == '') {
                newrow.X = '0.00'
              } else {
                newrow.X = parseFloat(this.otherrow.X).toFixed(2);
              }
              break;
            case 'type':
              newrow.type = this.otherrow.type;
              break;
            case 'Diameter':
              newrow.Diameter = this.otherrow.Diameter;
              break;
            case 'CommercialDiameter':
              newrow.CommercialDiameter = this.otherrow.CommercialDiameter;
              break;
            case 'ADD':
              newrow.ADD = this.otherrow.ADD;
              break;
            case 'A':
              newrow.A = this.otherrow.A;
              break;
            default:
              newrow[key] = this.buydetail[0][key];
              break;
          }
        }

        this.buydetail.push(newrow)

        var otherspecial = {}
        for (let key in this.specialgoods[0]) {
          otherspecial[key] = this.specialgoods[0][key];
        }
        otherspecial.type = newrow.type;
        otherspecial.X = newrow.X;
        otherspecial.Y = newrow.Y;
        this.specialgoods[0].LensCalculation = '1';
        otherspecial.LensCalculation = '0';
        this.specialgoods.push(otherspecial);

        var otherspecial2 = {}
        for (let key in this.specialgoodsV2[0]) {
          otherspecial2[key] = this.specialgoodsV2[0][key];
        }
        otherspecial2.type = newrow.type;
        otherspecial2.X = newrow.X;
        otherspecial2.Y = newrow.Y;
        this.specialgoodsV2.push(otherspecial2);

        this.drawer = false;
      },
      FillZero(p) {
        return new Array(4 - (p + '').length + 1).join('0') + p;
      },
      saveDataBatch(startindex) {//简单提交现片 不需要修改其他参数
        var index = startindex && startindex != '' ? startindex : 1;
        var erpserial = this.orderdata.erpserial + this.FillZero(index);
        index = index + 1;
        this.loading = true;
        var items = [];//一次两条
        for (let i in this.buydetail) {
          var number = this.buydetail[i].Number;
          if (number > 0) {
            var row = {}
            for (let key in this.buydetail[i]) {
              if (key == 'Number')
                row[key] = 1;
              else
                row[key] = this.buydetail[i][key];
            }
            items.push(row);
            number = number - 1;
            this.buydetail[i].Number = number;
          }
          if (items.length == 2)
            break;

          if (number > 0) {
            var row = {}
            for (let key in this.buydetail[i]) {
              if (key == 'Number')
                row[key] = 1;
              else
                row[key] = this.buydetail[i][key];
            }
            items.push(row);
            number = number - 1;
            this.buydetail[i].Number = number;
          }
          if (items.length == 2)
            break;
        }
        if (items.length > 0) {
          var cangkuname = ''
          for (let i in this.stocks) {
            if (this.stocks[i].code == this.form.cangkucode) {
              cangkuname = this.stocks[i].name.toUpperCase();
              break;
            }
          }
          var details = {
            type: this.buytype,
            ssotoken: this.form.ssotoken,
            customercode: this.form.customercode,
            comment: this.form.comment,
            comment2: this.form.comment2,
            goods: JSON.stringify(items),
            cangkucode: this.form.cangkucode,
            cangkuname: cangkuname
          };

          essiLorSaleOrder({
            erpserial: erpserial,
            details: JSON.stringify(details),
            saleerpserial: ''
          }).then(response => {
            if (response.data.code != 0) {
              this.$message({message: response.data.msg || '提交失败', type: 'error'})
              return
            }
            var self = this;
            setTimeout(function () {
              self.saveDataBatch(index);
            }, 1000)
          })

        } else {
          alert('推送成功！');
          this.$emit('saveDataNoESS');
          this.dialogSeeVisible = false;
        }
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (!valid)
            return;
          if (this.neewLensCalcution && this.hasproduct && this.buydetail.length == 1 && this.buydetail[0].Number == 1) {
            this.$message({message: '需要补充一个不生产商品！！', type: 'error'})
            return;
          }

          this.loading = true;
          for (let i in this.specialgoods) {
            var item = this.specialgoods[i];

            if (item.FrameType || item.FrameShape) {
              this.libojiagong = true;
            }
            if (this.libojiagong) {
              if (!item.FrameType || !item.FrameShape) {
                this.$message({message: '镜框必选！！', type: 'error'})
                this.loading = false;
                return;
              }
              for (let p in this.parames) {
                if (this.parames[p].name == '瞳距') {
                  if (!this.buydetail[i]['瞳距'] && (!this.buydetail[i]['右眼瞳距'] || !this.buydetail[i]['左眼瞳距'])) {
                    this.$message({message: '瞳距必填！！', type: 'error'})
                    this.loading = false;
                    return;
                  }
                } else {
                  if (!this.buydetail[i][this.parames[p].name]) {
                    this.$message({message: this.parames[p].name + '必填！！', type: 'error'})
                    this.loading = false;
                    return;
                  }
                }
              }
            }
            if (item.EdgingCode) {//加工项选割边：瞳高瞳距必填
              if (!this.buydetail[i]['瞳距'] && (!this.buydetail[i]['右眼瞳距'] || !this.buydetail[i]['左眼瞳距'])) {
                this.$message({message: '瞳距必填！！', type: 'error'})
                this.loading = false;
                return;
              }
              if (!this.buydetail[i]['瞳高']) {
                this.$message({message: '瞳高必填！！', type: 'error'})
                this.loading = false;
                return;
              }
            }

            var maxNum = (item.Prism1 == '棱镜' ? 30 : 50);
            if (item.Prism1 == '棱镜' || item.Prism1 == '移心') {
              if (!item.Decenter1) {
                this.$message({
                  message: '数值必填！',
                  type: 'error'
                })
                this.loading = false;
                return;
              }
              if (!item.Direction1) {
                this.$message({
                  message: '方向必填！',
                  type: 'error'
                })
                this.loading = false;
                return;
              }
            }

            if ((item.Decenter1 && (parseFloat(item.Decenter1) <= 0 || parseFloat(item.Decenter1) >= maxNum) ||
              (item.Decenter2 && (parseFloat(item.Decenter2) <= 0 || parseFloat(item.Decenter2) >= maxNum)))) {
              this.$message({
                message: '超范围：0<数值<' + maxNum + '！',
                type: 'error'
              })
              this.loading = false;
              return;
            }
          }

          for (let i in this.specialgoods) {
            var item = this.specialgoods[i];

            if (item.Prism1 == '移心') {
              item.Prism1 = ''
              item.Prism2 = ''
            } else if (item.Prism1 == '棱镜') {
              item.Prism1 = item.Decenter1
              item.Prism2 = item.Decenter2
              item.Decenter1 = ''
              item.Decenter2 = ''
            } else {
              item.Prism2 = ''
              item.Decenter1 = ''
              item.Decenter2 = ''
              item.Direction1 = ''
              item.Direction2 = ''
            }

            item.CoatingName = this.getName(item.CoatingCode, this.CoatingCode);
            item.EdgingName = this.getName(item.EdgingCode, this.EdgingCode);
            if (item.OtherProcessCode.length == 0)
              item.OtherProcessCode = '';
            item.OtherProcessName = this.getNameList(item.OtherProcessCode, this.OtherProcessCode);
            item.TintingName = this.getName(item.TintingCode, this.TintingCode);

            for (let key in this.specialgoodsV2[i]) {
              if (key == 'type' || key == 'X' || key == 'Y') {
                continue;
              }
              if (this.specialgoodsV2[i][key]) {
                this.specialgoods[i][key] = this.specialgoodsV2[i][key];
              }
            }
          }

          var cangkuname = ''
          for (let i in this.stocks) {
            if (this.stocks[i].code == this.form.cangkucode) {
              cangkuname = this.stocks[i].name.toUpperCase();
              break;
            }
          }
          var arr = {
            type: this.buytype,
            ssotoken: this.form.ssotoken,
            customercode: this.form.customercode,
            comment: this.form.comment,
            comment2: this.form.comment2,
            goods: JSON.stringify(this.buydetail),
            cangkucode: this.form.cangkucode,
            cangkuname: cangkuname,
            specialgoods: JSON.stringify(this.specialgoods)
          };
          this.$emit('afterEssilorBuy', JSON.stringify(arr));
          this.dialogSeeVisible = false
        });
      },
      getPackage(item) {
        var r = "";
        if (item.type)
          r += item.type + " ";
        if (item.Y)
          r += item.Y + "/" + item.X;
        return r;
      },
      getPackageType(item) {
        if (item.type)
          return item.type;
        return '';
      },
      getParam(item) {
        var r = "";
        if (item.A)
          r += "轴位:" + item.A + " ";

        if (item.ADD)
          r += "ADD:" + item.ADD + " ";
        if (item["通道"])
          r += "通道:" + item["通道"] + " ";
        if (item["右眼瞳距"]) {
          var v = parseFloat(item["右眼瞳距"]);
          if (v < 10 || v > 40) {
            this.$message({
              message: '右眼瞳距错误：10=<数值<=40！',
              type: 'error'
            })
            this.hasproduct = false;
          }
          r += "右眼瞳距:" + item["右眼瞳距"] + " ";
        }
        if (item["左眼瞳距"]) {
          var v = parseFloat(item["左眼瞳距"]);
          if (v < 10 || v > 40) {
            this.$message({
              message: '左眼瞳距错误：10=<数值<=40！',
              type: 'error'
            })
            this.hasproduct = false;
          }
          r += "左眼瞳距:" + item["左眼瞳距"] + " ";
        }

        for (let i in this.parames) {
          if (item[this.parames[i].name]) {
            if (this.parames[i].name != '瞳距' && this.parames[i].name != '瞳高')
              this.libojiagong = true;

            if (this.parames[i].name == '瞳距') {
              var v = parseFloat(item[this.parames[i].name]);
              if (v < 10 || v > 80) {
                this.$message({
                  message: '瞳距错误：10=<数值<=80！',
                  type: 'error'
                })
                this.hasproduct = false;
              }
            }

            if (this.parames[i].name == '瞳高') {
              var v = parseFloat(item[this.parames[i].name]);
              if (v < 10 || v > 40) {
                this.$message({
                  message: '瞳高错误：10=<数值<=40！',
                  type: 'error'
                })
                this.hasproduct = false;
              }
            }

            if (this.parames[i].name == '梁宽') {
              var v = parseFloat(item[this.parames[i].name]);
              if (v < 5 || v > 30) {
                this.$message({
                  message: '梁宽错误：5=<数值<=30！',
                  type: 'error'
                })
                this.hasproduct = false;
              }
            }

            r += this.parames[i].name + ":" + item[this.parames[i].name] + " ";
          }
        }
        return r;
      }
    },
    mounted() {
      let temp = localStorage.getItem("hpapi_userInfoModel")
      this.userInfoModel = JSON.parse(temp);
      this.showbatch = this.userInfoModel.mobile == '18951936669' || this.userInfoModel.mobile == '15250395939';
    },
    components: {}
  }
</script>

<style scoped>
  .framestyle {
    width: 100%;
    border: 0px;
    height: calc(100vh - 110px);
    background-size: 100% 100%;
    margin: 0px;
    padding: 0px;
  }
</style>





// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BuyfromEssilor.vue